const connectorPath = '/ckfinder/core/connector/php/connector'
const connectorUrl = `${process.env.VUE_APP_CKFINDER_URL}${connectorPath}`
const uploadUrl = `${connectorUrl}?command=QuickUpload&type=Images&responseType=json&langCode=zh-tw`

export const RESOURCE_TYPE = {
  AREA: 'Area', // 線別首頁上方輪播圖 & 手機版輪播圖
  CATALOG: 'Catalog', // 類別小圖 & 團控表大圖 & 團控表手機大圖
  CATALOG_BANNER: 'CatalogBanner', // 類別頁上方輪播圖
  BANNER: 'Banner', // 首頁輪播圖
  AIRLINE: 'AirLine',
  GIFT: 'Gift',
  PRODUCT: 'Product',
  PROJECT: 'Project',
  FLAG: 'Flag',
  IMAGES: 'Images',
  MEMBER: 'Member',
  FILES: 'Files',
  COLLABORATE_ACTIVITY: 'Activity',
  BLOG_SHARE: 'Blog',
  NEWS: 'News',
  Blog: 'Blog',
  EDM: 'Edm',
  MAGAZINES: 'Magazines',
  TOUR_LEADER: 'TourLeaders',
  SHARESTORY: 'ShareStory',
  SATISFACTIONS: 'Satisfactions'
}

// CKEditor 圖片
export const getCKFinderImagesConfig = area => {
  const resourceType = RESOURCE_TYPE.IMAGES
  const startupPath = area ? `${resourceType}:${area}` : null

  return {
    // Upload the images to the server using the CKFinder QuickUpload command.
    openerMethod: 'modal',
    uploadUrl: uploadUrl,

    // Define the CKFinder configuration (if necessary).
    options: {
      startupFolderExpanded: false,
      rememberLastFolder: false,
      language: 'zh-tw',
      resourceType,
      startupPath
    }
  }
}

export const getCKFinderBlogImagesConfig = () => {
  return {
    // Upload the images to the server using the CKFinder QuickUpload command.
    openerMethod: 'modal',
    uploadUrl: uploadUrl,

    // Define the CKFinder configuration (if necessary).
    options: {
      startupFolderExpanded: false,
      rememberLastFolder: false,
      language: 'zh-tw',
      resourceType: RESOURCE_TYPE.BLOG_SHARE,
      startupPath: RESOURCE_TYPE.BLOG_SHARE
    }
  }
}

export const getCKFinderNewsImagesConfig = () => {
  return {
    // Upload the images to the server using the CKFinder QuickUpload command.
    openerMethod: 'modal',
    uploadUrl: uploadUrl,

    // Define the CKFinder configuration (if necessary).
    options: {
      startupFolderExpanded: false,
      rememberLastFolder: false,
      language: 'zh-tw',
      resourceType: RESOURCE_TYPE.NEWS,
      startupPath: RESOURCE_TYPE.NEWS
    }
  }
}

export const getCKFinderOfferImagesConfig = () => {
  return {
    // Upload the images to the server using the CKFinder QuickUpload command.
    openerMethod: 'modal',
    uploadUrl: uploadUrl,

    // Define the CKFinder configuration (if necessary).
    options: {
      startupFolderExpanded: false,
      rememberLastFolder: false,
      language: 'zh-tw',
      resourceType: RESOURCE_TYPE.NEWS,
      startupPath: RESOURCE_TYPE.NEWS
    }
  }
}

export const getCKFinderEdmImagesConfig = () => {
  return {
    // Upload the images to the server using the CKFinder QuickUpload command.
    openerMethod: 'modal',
    uploadUrl: uploadUrl,

    // Define the CKFinder configuration (if necessary).
    options: {
      startupFolderExpanded: false,
      rememberLastFolder: false,
      language: 'zh-tw',
      resourceType: RESOURCE_TYPE.EDM,
      startupPath: RESOURCE_TYPE.EDM
    }
  }
}

export const getRelatePath = file => {
  let filePath = file.get('name')
  let folder = file.get('folder')

  while (folder) {
    if (folder.get('isRoot')) {
      break
    }

    const folderName = folder.get('name')
    filePath = `${folderName}/${filePath}`
    folder = folder.get('parent')
  }

  return filePath
}

// 首頁 輪播圖
export const OpenBannerFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.BANNER)
}

export const OpenProjectFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.PROJECT)
}

export const OpenProductFinder = area => {
  return OpenCKFinder(RESOURCE_TYPE.PRODUCT, `/${area}/`)
}

// 團別圖片
export const OpenProductCoverFinder = area => {
  if (area === 'Japan') {
    return OpenCKFinder(RESOURCE_TYPE.PRODUCT, `/${area}/團別圖片/`)
  } else {
    return OpenCKFinder(RESOURCE_TYPE.PRODUCT, `/${area}/Cover/`)
  }
}

// 路線圖片
export const OpenProductRouteFinder = area => {
  if (area === 'Japan') {
    return OpenCKFinder(RESOURCE_TYPE.PRODUCT, `/${area}/地圖/`)
  } else {
    return OpenCKFinder(RESOURCE_TYPE.PRODUCT, `/${area}/Route/`)
  }
}

// 內頁大圖
export const OpenProductBackgroundFinder = area => {
  if (area === 'Japan') {
    return OpenCKFinder(RESOURCE_TYPE.PRODUCT, `/${area}/內頁大底圖/`)
  } else {
    return OpenCKFinder(RESOURCE_TYPE.PRODUCT, `/${area}/Background/`)
  }
}

// 線別輪播圖
export const OpenAreaBannerFinder = (area, isMobile = false) => {
  let path = `/${area}/Banner${isMobile ? 'Mobile' : ''}/`

  return OpenCKFinder(RESOURCE_TYPE.AREA, path)
}

// 類別封面圖
export const OpenCatalogCoverFinder = area => {
  return OpenCKFinder(RESOURCE_TYPE.CATALOG, `/${area}/Cover/`)
}

// 類別團控圖
export const OpenCatalogOperationFinder = (area, isMobile = false) => {
  let path = `/${area}/Operation${isMobile ? 'Mobile' : ''}/`

  return OpenCKFinder(RESOURCE_TYPE.CATALOG, path)
}

// 類別輪播圖
export const OpenCatalogBannerFinder = (area, isMobile = false) => {
  let path = area ? `/${area}/Banner${isMobile ? 'Mobile' : ''}/` : `/`

  return OpenCKFinder(RESOURCE_TYPE.CATALOG_BANNER, path)
}

// 類別觀光資訊
export const OpenCatalogTouristInfoFinder = area => {
  let path = area ? `/${area}/TouristInfo/` : `/`

  return OpenCKFinder(RESOURCE_TYPE.CATALOG_BANNER, path)
}

// 航空公司Logo
export const OpenAirlineFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.AIRLINE)
}

// 國旗
export const OpenCountryFlagFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.FLAG)
}

// CKEditor 圖片
export const OpenImagesFinder = area => {
  return OpenCKFinder(RESOURCE_TYPE.IMAGES, `/${area}/`)
}

export const OpenMemberFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.MEMBER)
}

export const OpenFileFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.FILES)
}

export const OpenCollaborateActivityFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.COLLABORATE_ACTIVITY)
}

export const OpenBlogShareFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.BLOG_SHARE)
}

export const OpenNewsFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.NEWS)
}

export const OpenBlogFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.Blog)
}

export const OpenOfferFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.NEWS)
}

export const OpenEdmFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.EDM)
}

export const OpenMagazineFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.MAGAZINES)
}

export const OpenTourLeaderFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.TOUR_LEADER)
}

export const OpenSatisfactionsFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.SATISFACTIONS)
}

export const OpenShareStoryFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.SHARESTORY)
}

// 航空公司Logo
export const OpenGiftFinder = () => {
  return OpenCKFinder(RESOURCE_TYPE.GIFT)
}

const OpenCKFinder = (resourceType, path) => {
  return new Promise(function(resolve, reject) {
    if (!window.CKFinder) {
      reject('檔案上傳工具(CKFinder) 未初始化！')
      return
    }

    const startupPath = path ? `${resourceType}:${path}` : `${resourceType}:/`

    window.CKFinder.modal({
      chooseFiles: true,
      rememberLastFolder: false,
      language: 'zh-tw',
      resourceType,
      startupPath,
      onInit: function(finder) {
        finder.on('files:choose', function(evt) {
          const file = evt.data.files.first()
          const filename = getRelatePath(file)
          resolve(filename)
        })
      }
    })
  })
}
